export const SignupMemberships = {
  GUEST: 'Guest',
  VIP: 'Vip',
  GSHOP: 'GSHOP',
};
